/* Interactive flour characteristic icons. No label shown initially. */
(function(){
  'use strict';
  var activeButton=null, activeRow=null;

  function eventButton(e){
    return e.target && e.target.closest ? e.target.closest('[data-rp-badge-label]') : null;
  }
  function clearActive(){
    if(activeRow){
      var label=activeRow.querySelector('[data-rp-badge-description]');
      if(label)label.textContent='';
      activeRow.querySelectorAll('[data-rp-badge-label]').forEach(function(el){
        el.setAttribute('aria-pressed','false');
      });
    }
    activeButton=null;
    activeRow=null;
  }
  function showBadge(button){
    if(!button)return;
    var row=button.closest('[data-rp-feature-badges]');
    if(!row)return;
    var label=row.querySelector('[data-rp-badge-description]');
    if(!label)return;
    if(activeRow&&activeRow!==row)clearActive();
    activeRow=row;activeButton=button;
    row.querySelectorAll('[data-rp-badge-label]').forEach(function(el){
      el.setAttribute('aria-pressed',String(el===button));
    });
    label.textContent=button.getAttribute('data-rp-badge-label')||'';

    /* Float beside the icons, or above when there is no space. No layout shift. */
    label.style.top='0px';
    label.style.left='0px';
    var icons=row.querySelector('.rp-feature-badges__icons');
    var left=icons ? icons.getBoundingClientRect().right-row.getBoundingClientRect().left+7 : 0;
    var rowWidth=row.getBoundingClientRect().width;
    if(left+label.getBoundingClientRect().width<=rowWidth){
      label.style.left=Math.max(0,left)+'px';
    }else{
      var buttonLeft=button.getBoundingClientRect().left-row.getBoundingClientRect().left;
      var labelWidth=label.getBoundingClientRect().width;
      label.style.left=Math.max(0,Math.min(buttonLeft,rowWidth-labelWidth))+'px';
      label.style.top=-(label.getBoundingClientRect().height+4)+'px';
    }
  }
  document.addEventListener('pointerover',function(e){
    if(e.pointerType==='mouse'||e.pointerType==='pen')showBadge(eventButton(e));
  });
  document.addEventListener('pointerout',function(e){
    if(e.pointerType!=='mouse'&&e.pointerType!=='pen')return;
    var button=eventButton(e);
    if(button===activeButton && button && !button.contains(e.relatedTarget))clearActive();
  });
  document.addEventListener('click',function(e){
    var button=eventButton(e);
    if(!button){clearActive();return;}
    e.preventDefault();
    var touch=e.pointerType==='touch'||(window.matchMedia&&window.matchMedia('(hover: none)').matches);
    if(touch&&button===activeButton)clearActive();
    else showBadge(button);
  });
  document.addEventListener('focusin',function(e){
    var button=eventButton(e);
    if(button&&button.matches(':focus-visible'))showBadge(button);
  });
  document.addEventListener('focusout',function(e){
    var button=eventButton(e);
    if(button&&button===activeButton&&!button.contains(e.relatedTarget))clearActive();
  });
  window.addEventListener('scroll',clearActive,{passive:true,capture:true});
  window.addEventListener('touchmove',clearActive,{passive:true});
})();
